import { transportBodyTypes, transportCategories } from "../../components/search/categories";

/**
 * Search catalogues shared by every search window (Home, Find transport, Find loads).
 * Body types are the full legacy list (groups «Закрытые», «Открытые», … with their kinds),
 * not only the kinds present among the trucks that happen to be online.
 */

const parents = transportBodyTypes.filter((b) => b.parent_id == null);

/** [{ id, name, kinds: [{ id, name }] }] — for <optgroup>. */
export const BODY_GROUPS = parents.map((p) => ({
  id: p.id,
  name: p.name,
  kinds: transportBodyTypes.filter((b) => b.parent_id === p.id).map((b) => ({ id: b.id, name: b.name })),
}));

/** every kind name that belongs to a group name */
const KINDS_OF = new Map(BODY_GROUPS.map((g) => [g.name, new Set(g.kinds.map((k) => k.name))]));

/** Does a truck/load body type name satisfy the selected search option (a kind or a whole group)? */
export function bodyMatches(selected, name) {
  if (!selected || selected === "Любой") return true;
  if (!name) return false;
  if (name === selected) return true;
  const kinds = KINDS_OF.get(selected);
  return !!kinds && kinds.has(name);
}

export const CATEGORY_OPTIONS = transportCategories.map((c) => ({ value: c.label, label: c.label }));

/** Грузоподъёмность: «любая» + 4 steps (business request). */
export const CAPACITY_OPTIONS = [
  { value: "0", label: "Любая" },
  { value: "1", label: "от 1 тонны" },
  { value: "5", label: "от 5 тонн" },
  { value: "10", label: "от 10 тонн" },
  { value: "20", label: "от 20 тонн" },
];

/** Объём: любая, от 1 / 10 / 50 / 100 м³. */
export const VOLUME_OPTIONS = [
  { value: "", label: "Любой" },
  { value: "1", label: "от 1 м³" },
  { value: "10", label: "от 10 м³" },
  { value: "50", label: "от 50 м³" },
  { value: "100", label: "от 100 м³" },
];
